export default "__VITE_ASSET__ELX5DSZc__"